var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('span',[_vm._v("Received Meals: "+_vm._s(_vm.mealCountCalc.availableCount))]),_c('mc-serve',{attrs:{"mealCounts":_vm.viewModel},on:{"update:mealCounts":function($event){_vm.viewModel=$event},"update:meal-counts":function($event){_vm.viewModel=$event},"input-changed":_vm.inputChanged}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }